import { colors } from './colors';

const borders = {} as const;

export default borders;

export type ThemeBorders = typeof borders;
export type ThemeBordersKeys = keyof typeof borders;
